module.exports = __webpack_public_path__ + "static/media/product_sample_9.07bfe9fb.jpg";